var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.data.type,{tag:"component",attrs:{"data":_vm.data,"services":_vm.services,"callback":function(data){_vm.callback(data)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }